import { gql } from "@apollo/client";

export const GetAllGroupsQuery = gql`
  query Query {
    getAllGroups
  }
`;
